import React from 'react';

/**
 * Bouton unique de l'application. Chaque variante a une bordure et un texte francs :
 * seul `disabled` estompe le bouton (avant, « Annuler » gris sur fond transparent
 * ressemblait à un bouton désactivé).
 *
 * variant : primary | secondary | danger | success | warning | sidebar (fond sombre)
 * size    : md (actions de page / de modale) | sm (actions dans un tableau)
 * `style` ne sert qu'aux marges / largeur, pas aux couleurs.
 */
const VARIANTS = {
  primary:   { background: '#232853', borderColor: '#232853', color: '#ffffff' },
  secondary: { background: '#ffffff', borderColor: '#6376aa', color: '#232853' },
  danger:    { background: '#fdecea', borderColor: '#e09a92', color: '#b3261e' },
  success:   { background: '#e2f3e8', borderColor: '#86c497', color: '#1a7f37' },
  warning:   { background: '#fff4e0', borderColor: '#e0b25e', color: '#955d00' },
  sidebar:   { background: 'transparent', borderColor: '#6376aa', color: '#ffffff' },
};

const SIZES = {
  md: { padding: '0.5rem 1.1rem', fontSize: '0.9rem', borderRadius: '8px' },
  sm: { padding: '0.35rem 0.8rem', fontSize: '0.82rem', borderRadius: '6px' },
};

// Survol : règles CSS .ui-btn:hover (ui.css), pas d'état JS
export default function Button({ variant = 'secondary', size = 'md', type = 'button', disabled, style, className, children, ...props }) {
  return (
    <button
      type={type}
      disabled={disabled}
      className={['ui-btn', `ui-btn--${variant}`, className].filter(Boolean).join(' ')}
      style={{
        ...base,
        ...SIZES[size],
        ...VARIANTS[variant],
        ...(disabled ? disabledStyle : {}),
        ...style,
      }}
      {...props}
    >
      {children}
    </button>
  );
}

const base = {
  display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: '0.35rem',
  border: '1px solid', fontWeight: 600, lineHeight: 1.2, cursor: 'pointer',
  whiteSpace: 'nowrap', textWrap: 'nowrap', fontFamily: 'inherit',
};
const disabledStyle = { opacity: 0.45, cursor: 'not-allowed' };
